import * as Sentry from '@sentry/react';
import { debuglog } from './Log';

const inDev = window.location.hostname.startsWith('localhost');

type SentryExtras = Record<string, unknown>;


export const init = () => {
  if (!inDev) {
    Sentry.init({
      dsn: 'https://4f8c54802d9641a27746eac6b03a2d35@o4506555426275328.ingest.sentry.io/4506555429355520',
      integrations: [],
    });
  }
};

const withExtras = (extras: SentryExtras | undefined, callback: () => void) => {
  if (!extras || Object.keys(extras).length === 0) {
    callback();
    return;
  }
  Sentry.withScope((scope) => {
    scope.setExtras(extras);
    callback();
  });
};

export const captureMessage = (message: string, extras?: SentryExtras) => {
  if (!inDev) {
    withExtras(extras, () => Sentry.captureMessage(message));
  }
  else{
    debuglog('sentry message not sent because in dev: ', message, extras);
  }
};

export const captureException = (error: unknown, extras?: SentryExtras) => {
  if (!inDev) {
    withExtras(extras, () => Sentry.captureException(error));
  }
};
